import { useFeatureFlagEnabled } from "@posthog/react";

import { MESSAGING_ENABLED_FLAG_KEY } from "../lib/feature-flags";

/**
 * Resolves the `messaging_enabled` gate (plan 289 D19): the header messaging
 * icon + `/threads` surfaces launch PRE-marketplace as a standalone platform
 * feature, ramped in prod via PostHog cohort.
 *
 * Mirrors `resolveMarketplaceBrowseEnabled` — DEV renders unconditionally
 * (dev-phase-no-flags rule); in a loaded/production PostHog context only an
 * EXPLICIT `true` enables the surfaces. This is the inverse default of
 * `resolveOffersEnabled` (undefined→ON) deliberately: D19 frames the flag as
 * a "prod cohort-ramp," i.e. starts at 0% and is dialed up per cohort, not a
 * kill-switch that defaults everyone on.
 */
export function resolveMessagingEnabled(
  flagValue: boolean | undefined,
  dev: boolean,
): boolean {
  return dev || flagValue === true;
}

export function useMessagingEnabled(): boolean {
  const flagValue = useFeatureFlagEnabled(MESSAGING_ENABLED_FLAG_KEY);
  return resolveMessagingEnabled(flagValue, import.meta.env.DEV);
}
